<template>
  <div class="SellReportPage page">
    <div class="page-title">
      <span>Orders Report</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
          <option
            v-for="rate in (getCurrencyRates)"
            :value="rate.toCurrency"
            :key="rate.id"
          >
          {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" @onChangeOrderStatus="onChangeOrderStatus" @onChangePaymentStatus="onChangePaymentStatus" :disableCompareDate="false" :queryMode="this.query.mode" @onChangeSalesperson="onChangeSalesperson"/>
    <div class="column-filter">
      <UiReportList :reportList="reportList" />
    </div>
    <UiChart v-if="!loading && (tippingsSummary && tippingsSummary.items && typeof (tippingsSummary.items) === 'object')" :series="prepareChartSeries(tippingsSummary)" :options="prepareChartOptions(tippingsSummary)"/>
    <UiTableOrderReport :report="orderReport" :colsData="[]"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiChart from '@/components/UiChart'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiReportList from '@/components/UiReportList'
import UiTableOrderReport from '@/components/UiTableOrderReport'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'Tippings',
  components: {
    UiFilterbar,
    UiChart,
    UiReportList,
    UiTableOrderReport
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        registerIds: null,
        timeZone,
        reportingMode: 'in_store'
      },
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      reportList: reportListData.orders,
      filteredFields: []
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      orderReport: 'report/getOrderTippingReportData',
      tippingsSummary: 'report/getOrderTippingSummary',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    })
  },
  methods: {
    ...mapActions({
      getReport: 'report/getTippingReportDataByStore',
      getReportSummary: 'report/getTippingReportSummary'
    }),
    selectCurrency () {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }
      
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...this.day
        }
      })

      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.query.states = states
      this.query.statuses = statuses
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states,
          statuses
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    onChangeOrderStatus (reportingMode, outletIds, registerIds, day, type, states) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    onChangeSalesperson (salemen) {
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          salemen: salemen
        }
      })
      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          salemen: salemen
        }
      })
    },
    onChangePaymentStatus (reportingMode, outletIds, registerIds, day, type, statuses) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          statuses,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds, states, statuses) {
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.getReportSummary({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states,
          statuses
        }
      })
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.tippings,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    toggleColumnFilter () {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
    },
    documentClick (e) {
      const el = this.$refs.columnsList
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.isShowColumnsSelect = false
      }
    },
    formartDate (item) {
      if (item.day != null && (item.week == null || item.month == null || item.year == null)) {
        return moment.utc(new Date(moment(item.day).toDate())).format('MMM DD YYYY')
      } else if (item.week != null) {
        return `Week ${item.week}`
      } else if (item.month != null && item.year != null) {
        return `${item.month} / ${item.year}`
      } else if (item.year != null) {
        return item.year
      } else {
        return ''
      }
    },
    formatTotal (total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    prepareChartOptions (reports) {
      const dateList = reports && reports.items && reports.items.length > 0 ? reports.items.map(item => {
        return this.formartDate(item)
      }) : []
      return {
        chart: {
          id: 'tippings-chart',
          type: 'bar',
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        dataLabels: {
          style: {
            colors: ['#000000']
          },
          formatter: (value, index) => {
            return this.formatTotal(value, Object.keys(reports.items)[index.dataPointIndex] && reports.items[Object.keys(reports.items)[index.dataPointIndex]] ? reports.items[Object.keys(reports.items)[index.dataPointIndex]] : null)
          }
        },
        plotOptions: {
          bar: {
            columnWidth: dateList.length === 1 ? '15%' : dateList.length <= 3 ? '30%' : '70%'
          }
        },
        noData: {
          text: 'No data'
        },
        xaxis: {
          categories: dateList
        },
        yaxis: {
          labels: {
            formatter: value => { return this.formatTotal(value) }
          }
        }
      }
    },
    prepareChartSeries (reports) {
      const valueList = reports && reports.items ? Object.keys(reports.items).map(item => parseFloat(reports.items[item].totalTipping || 0).toFixed(6)) : []
      return [{
        name: i18n.t('Total amount'),
        data: valueList
      }]
    },
    getTimeZone () {
      return Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  created () {
    const self = this

    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }

    window.addEventListener('click', function (e) {
      if (!self.$el.contains(e.target)) {
        self.isShowColumnsSelect = false
      }
    })
  },
  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter {
    display: flex;
    justify-content: space-between;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
</style>
